import request from '@/utils/request'

export const getServiceIndustry = () =>
  request({
    url: '/services_industries?page=1&per_page=100',
    method: 'get'
  })

  export const getServiceType = (industryId: any) =>
  request({
    url: '/services_industries.types?service_industry_id=' + industryId + '&per_page=100&page=1',
    method: 'get'
  })

  export const getServices = (serviceType: any) =>
  request({
    url: '/visibility/getServices?service_type_id=' + serviceType,
    method: 'get'
  })

  export const setVisibility = (data: any) =>
  request({
    url: '/visibility/set',
    method: 'post',
    data
  })

  export const deleteVisibility = (data: any) =>
  request({
    url: '/visibility/set',
    method: 'delete',
    data
  })

  export const getPinnedProfessionals = (serviceTypeId: any) =>
  request({
    url: '/visibility/getPinnedProfessionals?serviceTypeId=' + serviceTypeId,
    method: 'get'
  })

  export const saveVisibility = (data: any) =>
  request({
    url: '/visibility/saveVisibility',
    method: 'post',
    data
  })

  export const getServiceProviders = () =>
  request({
    url: '/service_providers/get-list',
    method: 'get'
  })

  export const saveReview = (data: any) =>
  request({
    url: '/admin/reviews',
    method: 'post',
    data
  })
